(() => {
  if (window.dwBannerHeightSync) return;
  window.dwBannerHeightSync = true;
  function update(img) {
    const banner = img.closest('.m6fr');
    if (!banner) return;
    const host = banner.matches('.swiper-initialized') ? banner : banner.querySelector('.swiper-initialized');
    if (host?.swiper && !host.swiper.destroyed) host.swiper.updateAutoHeight(0);
  }
  const observer = new ResizeObserver(entries => entries.forEach(entry => update(entry.target)));
  function init() {
    document.querySelectorAll('.m6fr .slideshow-picture img').forEach(img => {
      if (img.dataset.dwHeightObserved) return;
      img.dataset.dwHeightObserved = 'true';
      img.addEventListener('load', () => update(img));
      observer.observe(img);
      if (img.complete) update(img);
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
